import { render, staticRenderFns } from "./CopyrightEscalations.vue?vue&type=template&id=2ae3d7d0&scoped=true&"
import script from "./CopyrightEscalations.vue?vue&type=script&lang=js&"
export * from "./CopyrightEscalations.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightEscalations.vue?vue&type=style&index=0&id=2ae3d7d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae3d7d0",
  null
  
)

export default component.exports